import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupRestrictedActionsOffAllContentProps {
  message: Msg;
}

export const MsgGroupRestrictedActionsOffAllContent = memo(
  function MsgGroupRestrictedActionsOffAllContent({
    message,
  }: MsgGroupRestrictedActionsOffAllContentProps) {
    const { operator_user_id } = message.payload;

    const { user: operatorUser } = useUserInfo(operator_user_id);

    return (
      <MyTrans
        i18nKey="chat.groupMessageRestrictedActionsOffAllText"
        components={{
          actionUser: (
            <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />
          ),
          action: <Text as="span" color="fg.muted" />,
        }}
      ></MyTrans>
    );
  }
);
